<template>
  <div class="top-box">
    <img class="banner-bg" :src="require('../../assets/'+appTheme+'/banner_bg.png')" alt="" />
    <div class="top-content">
      <div id="new-home-search-form">
        <!--          <van-search-->
        <!--            v-model="searchInput"-->
        <!--            shape="round"-->
        <!--            background="#fdd80d"-->
        <!--            placeholder="精品专区一元秒杀中，比拼多多最低还要低，千万别错过"-->
        <!--          />-->
        <div class="search-box left-justifying" @click="goSearch">
          <img :src="require('../../assets/'+appTheme+'/search_icon.png')" alt="" />
          <div class="animate-txt-box">
            <div class="animate-txt">数字灯云：集科技金融、电子商务、数字溯源、直播电商、跨境电商、进出口贸易、大宗交易、出口进口服务、人才培训、共性服务等      <span style="display: inline-block;margin: 0 17.33333vw;">加盟热线：400 096 0592</span>       </div>
          </div>
        </div>
      </div>
      <div class="banner-box">
        <div class="banner-img-box">
          <van-swipe style="height: 50.4vw;" :autoplay="5000" class="my-swipe" :show-indicators="false">
            <van-swipe-item v-for="(image, index) in param.data" :key="index" @click="goGoodDes(image.url)">
              <img v-lazy="image.image" class="banner-img-item" :src="image.image" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <img class="decorate-img" :src="require('../../assets/'+appTheme+'/decorate_img.png')" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bannerItem",
  props:['param'],
  data(){
    return{
      appTheme:this.$store.state.appTheme
    }
  },
  methods:{
    goSearch(){
      this.$router.push('/searchList');
    },
    goGoodDes(url){
      // console.log(url)
      window.open(url)
      // this.$router.push({path: url})
    },
  }
}
</script>

<style lang="scss" scoped>
.top-box {
  position: relative;
  .banner-bg{
    width: 100%;height: auto;display: block;
  }
  .top-content{
    position: absolute;
    width: 100%;left: 0;top: 0;
    #new-home-search-form{
      width: 696px;
      height: 60px;line-height: 60px;
      background: rgba(255, 255, 255, 0.63);
      border-radius: 30px; margin: 29px auto 24px;font-size: 24px;color: #8C8C8C;font-weight: 400;overflow: hidden;
      img{
        width: 34px;height: auto;margin-left: 20px;display: inline-block;
      }
      .animate-txt-box{
        width: 610px;margin-left: 10px;
        overflow: hidden;display: inline-block;
      }
      .animate-txt{
        height: 60px;line-height: 60px;
        display: inline-block;
        white-space: nowrap;
        animation: 20s wordsLoop linear infinite normal;
      }
    }
    .banner-box{
      //width: 750px;overflow: hidden;
      width: 696px;margin: 24px auto 0;overflow: hidden;
      .decorate-img{
        width: 100%;height: auto;display: block;margin-top: -80px;position: relative;z-index: 1;
      }
      .banner-img-box{
        border-radius:8px;
        overflow: hidden;
        .my-swipe{
          height: 378px;
        }
        .banner-img-item{
          width: 100%;display: block;
          height: 378px;
        }
      }

    }
  }
}
@keyframes wordsLoop {
  0% {
    transform: translateX(200px);
    -webkit-transform: translateX(200px);
  }
  100% {
    transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
  }
}

@-webkit-keyframes wordsLoop {
  0% {
    transform: translateX(200px);
    -webkit-transform: translateX(200px);
  }
  100% {
    transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
  }
}
</style>
